import BaseManager from "@base/manager/BaseManager";
import Facade from "../../Facade";
import UIBehaviors from "./UIBehaviors";
import Signals from "@/signals/GameSignals";
import GameStatesEnum from "@/states/GameStatesEnum";
import * as PIXI from "pixi.js";
import Config from "@/config/Config";
import Platform from "@base/utils/Platform";
import FormatData from "@/application/FormatData";
import ScaleManager from "@/stage/ScaleManager";
import UIPopupManager from "@/managers/ui/UIPopupManager";
import {getBuyBonusRTPByGameCode} from "@/config/GameRTP";
import UIFacade from "@baseUI/UIFacade";

export default class UIManager extends BaseManager {

    constructor() {
        super()
        new UIBehaviors()
        Facade.isSpaceToSpin = true
        this.isMuted = false
        this.gameEntered = false
        this.soundValue = true
        this.musicValue = true
        this.blurFilter = new PIXI.filters.BlurFilter()
        this.blurFilter.blurX = 10
        this.blurFilter.blurY = 10
        this.blurFilter.autoFit = true
        this.addListeners()

        this.uiPopupController = new UIPopupManager()
    }

    initUI() {

        this.uiPopupController.init()

        this.autospin = {
            value: 0, singleWin: '-', cashIncrease: '-', cashDecrease: '-', whenEnteringFreeSpins: false
        }

        document.dispatchEvent(new CustomEvent("ui:init", {
            detail: {
                safeFrame: ScaleManager.currentSizes.safe,
                container: Facade.mainContainer.uiContainer,
                menuContainer: Facade.mainContainer.uiMenuContainer,
                locale: Facade.locale,
                showTime: true,
                paytable: Facade.model.symbolsPayout,
                rtp: Facade.model.display_rtp || Facade.model.rtp,
                rtpBonusBuy: getBuyBonusRTPByGameCode(Facade.urlParams.gameCode).bonusBuy,
                maxwin: Facade.model.display_rtp ? "x5000 (<1:1000000000)" : undefined,
                historyUrl: Facade.model.historyUrl,
                buyFreebet: Facade.model.buyFreebet,
                autospinList: Facade.model.autospinList,
                freeSpinTotalCount: Facade.model.freeSpinTotalCount,
                amountLeft: Facade.model.amountLeft,

                //buyButton: false,
                soundChecked: true,
                musicChecked: true,
                isQuickSpin: Facade.isQuickSpin,
                whenEnteringFreeSpins: this.autospin.whenEnteringFreeSpins,
                volume: {
                    visible: false
                },
                home: {
                    visible: Facade.urlParams.customer === 'relax' || !!Facade.model.lobbyURL
                },
                isAutospinShow: Facade.model.autospinList.length === 0 ? false : Facade.urlParams.autoSpin,
                fullscreen: false,
                toFixed: Config.TO_FIXED_VALUES,
                currency: Facade.model.currentcyCode,
                possibleBetsValues: Facade.model.betPossible,
                possibleBets: Facade.model.totalBetsList,
                totalBuyListBet: Facade.model.totalBuyListBet,
                currentBetIndex: Facade.model.currentBetIndex,
                autoSingleWinValues: Config.autoSingleWinValues,
                autoIncreasesValues: Config.autoIncreasesValues,
                autoDecreasesValues: Config.autoIncreasesValues,
                setAutospinValues: Config.setAutospinValues,
                autoStopBalanceLowerValues: Config.autoStopBalanceLowerValues,
                autoStopBalanceHigherValues: Config.autoStopBalanceHigherValues,
                autoStopMoneyExceedValues: Config.autoStopBalanceHigherValues,
                spaceToSpin: {
                    visible: !Platform.isMobile(), enable: Facade.isSpaceToSpin
                }
            }
        }))

// TODO: delete it
        document.dispatchEvent(new CustomEvent("setButtonState", {
            detail: {
                fullscreen: {
                    visible: !Platform.isIPhone()
                }, fullScreenPortraitLabel_TEXT: {
                    visible: !Platform.isIPhone()
                }
            }
        }))
    }

    addListeners() {
        Signals.setMuteButtons.add(this.onSetMuteButtons, this)
        Signals.initUI.add(this.initUI, this)
        Signals.muteClick.add(this.onMuteClickEvent, this);

        document.addEventListener("tap", this.onTap)
        document.addEventListener("changeModelUi", this.onChangeModelUi)
        document.addEventListener("betChangeUi", this.onBetChangeUi)


        document.body.onkeydown = (e) => {
            if (e.key == ' ' && !Facade.model.isAuto && !Facade.model.freespins?.total_amount_given && Facade.isSpaceToSpin && UIFacade.model.isAutospinShow) {
                if (Facade.model.currentState == GameStatesEnum.SPIN_START ||
                    Facade.model.currentState == GameStatesEnum.GET_SPIN_RESPONSE ||
                    Facade.model.currentState == GameStatesEnum.SPIN_STOP
                ) {
                    //this.onStopClick()
                } else {
                    if (!UIBehaviors.getEnableUIDelay() && !UIFacade.model.showSettings && !Facade.model.bigWin) this.onSpinClick()
                }
            }
        }

        this.onSetMuteButtons(true)
    }

    onChangeModelUi(data) {
        const detail = data.detail
        switch (detail.name) {
            case "autoplaySettings":
                // Facade.model.autoStopCount = detail.value.autoStopCount
                // Facade.model.autoStopBalanceLower = detail.value.autoStopBalanceLower
                // Facade.model.autoStopBalanceHigher = detail.value.autoStopBalanceHigher
                // Facade.model.autoStopMoneyExceed = detail.value.autoStopMoneyExceed


                const value = detail.value.autoStopCount
                const singleWin = -1
                const cashIncrease = detail.value.autoStopBalanceHigher
                const cashDecrease = detail.value.autoStopBalanceLower
                const whenEnteringFreeSpins = false

                const data = {
                    value, singleWin, cashIncrease, cashDecrease, whenEnteringFreeSpins
                }
                if (value !==-1 || singleWin !== -1 || cashIncrease!==-1 || cashDecrease!==-1){
                    Signals.setAutoplay.dispatch(data)
                }
                break
        }

    }

    onBetChangeUi(data) {
        Facade.model.currentBetIndex = data.detail.value
    }

    onTap = (e) => {
        const detail = e.detail
        console.log('#########  onTap ', detail.name );
        switch (detail.name) {

            case "spaceToSpin":
                Signals.btnClick.dispatch()
                Facade.isSpaceToSpin = detail.value
                break

            case "home":
                Signals.btnClick.dispatch()
                Signals.quitHandler.dispatch();
                window.location.replace(Facade.model.lobbyURL)
                break

            case "quickSpin":
                Signals.btnClick.dispatch()
                Facade.isQuickSpin = detail.value
                break

            case "autoplay":
                Signals.btnClick.dispatch()
                break

            case "autoplayCounter":
                Signals.stopAutoplay.dispatch(true)
                break

            case "singleWin":
                this.autospin.singleWin = detail.value
                break

            case "minus":
                Signals.playBuyDecreaas.dispatch()
                this.autospin.cashDecrease = detail.value
                break

            case "plus":
                Signals.playBuyIncreas.dispatch()
                this.autospin.cashIncrease = detail.value
                break

            case "whenEnteringFreeSpins":
                this.autospin.whenEnteringFreeSpins = detail.value
                break

            case "fullscreen":
                Signals.btnClick.dispatch()
                Signals.requestFullScreen.dispatch(detail.value)
                break
            case "spin":
                Signals.btnClick.dispatch()
                this.onSpinClick()
                break

            case "stop":
                this.onStopClick()
                break

            case "maxBet":
                Signals.btnClick.dispatch()
                Facade.model.setMaxBet()
                break

            case "info":
                Signals.btnClick.dispatch()
                break

            case "music":
                Signals.btnClick.dispatch()
                this.onMusicClick(detail.value)
                break

            case "sound":
                Signals.btnClick.dispatch()
                this.onSoundClick(detail.value)
                break

            case "menuBet":
            case "menuAutoplay":
            case "menuInfo":
            case "menuBetHistory":
            case "menuSettings":
                Signals.btnClick.dispatch()
                break

            case "mute":
                Signals.btnClick.dispatch()
                this.onMuteClick(detail.value)
                break

            case "settingsMusic":
                Signals.btnClick.dispatch()
                this.onMuteClick(detail.value)
                break

            case "panelBuyButtons":
                Signals.btnClick.dispatch()
                break;

            case "buyBuyButton":
                Signals.btnClick.dispatch()
                //      Signals.buyBtnPressed.dispatch()
                break

            case "buyConfirm":
                console.log('***** InterfMeneger buyConfirm', detail.id, detail.price)
                Facade.model.buyFreebetChoose = {id: detail.id, price: detail.price}
                Signals.btnClick.dispatch()
                Signals.buyBtnPressed.dispatch()
                break

            case "betHistory":
                Signals.btnClick.dispatch()
                window.open(Facade.model.historyUrl, '_blank').focus();
                break;

            case "autoplayStop":
                Signals.stopAutoplay.dispatch()
                break;

            case "betConfirm":
                Signals.btnClick.dispatch()
               break;

            case "betChangeBuy":
               // Signals.btnClick.dispatch()
                Facade.model.currentBetIndex = detail.value
                Signals.currentBuyFreebetChanged.dispatch()
                break;
        }
    }

    onMuteClick(value) {
        Signals.muteClick.dispatch(value)
    }

    onMuteClickEvent(value) {
        document.dispatchEvent(new CustomEvent("setButtonState", {
            detail: {
                mute: {
                    checked: !!value,
                },
                music: {
                    enable: !!value,
                },
                sound: {
                    enable: !!value,
                }
            }
        }))
        this.isMuted = !this.isMuted
    }

    onSoundClick(value) {
        this.soundValue = value
        if (this.musicValue == value || value == true) {
            document.dispatchEvent(new CustomEvent("setButtonState", {
                detail: {
                    mute: {
                        checked: value
                    }
                }
            }))
        }
        Signals.soundClick.dispatch(value)
    }

    onMusicClick(value) {
        this.musicValue = value
        if (this.soundValue == value || value == true) {
            document.dispatchEvent(new CustomEvent("setButtonState", {
                detail: {
                    mute: {
                        checked: value
                    }
                }
            }))
        }
        Signals.musicClick.dispatch(value)
    }

    onSetMuteButtons(value) {
        this.soundValue = value
        this.musicValue = value
        document.dispatchEvent(new CustomEvent("setButtonState", {
            detail: {
                sound: {
                    checked: value,
                }, music: {
                    checked: value
                }
            }
        }))
    }


    onSpinClick() {
        Signals.spinBtnPressed.dispatch()
        console.log('----------------onSpinClick-----------------');
    }

    onStopClick() {
        this.onSpinClick()
        document.dispatchEvent(new CustomEvent("setButtonState", {
            detail: {
                spin: {
                    enable: false, visible: true
                }
            }
        }))
    }

}
